// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"786":"8c5cdbac","874":"77d665c7"}[chunkId] + ".chunk.css";
};